import { render, staticRenderFns } from "./MultibookList.vue?vue&type=template&id=588be768&"
import script from "./MultibookList.vue?vue&type=script&lang=js&"
export * from "./MultibookList.vue?vue&type=script&lang=js&"
import style0 from "./MultibookList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports